import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { CEUMA_URL_API } from 'app/config';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { Observable } from 'rxjs';
import { DadosVestibular, InscricaoResponse } from 'models/dados-vestibular';
import { environment } from 'environments/environment';

export const INSCRICAO_API_URL = CEUMA_URL_API + '/inscricao/';

@Injectable()
export class InscricaoService {

  environment = environment;
  idUsuarioMoodle;
  courses;
  responseInsereAlunoProvaOnlineMoodle;
  usuarioMoodle;

  private headers: HttpHeaders = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
    private stringUtil: StringUtilsService,
  ) { }

  inscrever(dadosVestibular: DadosVestibular,newVestibular=null): Promise<InscricaoResponse> {
    //console.log(dadosVestibular);
    /**
     * Mudança feita por 4583 - Thiago Augusto Lopes Silva
     * Novo processo de inscrição com dialog flow não é necessário fazer o preinput, pois o json já foi montado
     * Portanto, adicionando um if
     */

    dadosVestibular.contexto = environment.loginContexto;
    let inputInscricao = dadosVestibular;
    //console.log(dadosVestibular);
    if(newVestibular==null) inputInscricao = this.prepInputInscricao(dadosVestibular);

    return new Promise<any>((resolvido, rejeitado) => {
      this.http.post(INSCRICAO_API_URL, inputInscricao, { headers: this.headers }).subscribe(
        (resp: any) => {
          if (!resp || resp.codigo) {
            rejeitado({ erro: resp });
          } else {
            resolvido(new InscricaoResponse({
              numeroInscricao: resp.numeroInscricao ? resp.numeroInscricao.trim() : '',
              agendamento: {
                predio: resp.descricaoPredio ? resp.descricaoPredio.trim() : '',
                sala: resp.descricaoSala ? resp.descricaoSala.trim() : '',
              },
              valorVestibular: resp.valorVestibular
            }));
          }
        },

        (err: any) => {
          if (!err || err.codigo) {
            rejeitado({ erro: err });
          } else {
            rejeitado({ erro: { mensagem: 'Ocorreu um erro ao tentar realizar a inscrição' } });
          }
        },
      );
    });
  }

   migraAlunoProvaOnlineMoodle(dadosVestibular,numeroInscricao){
    /**
     * Primeiramente buscamos o código da turma, pois caso não existe, não migraremos o candidato
     * Depois o aluno precisa ser inserido primeiramente no Moodle
     * Por último, inserimos o aluno na turma
     */
    //Buscando usuário do moodle para saber se o mesmo existe.
    // Verifica se a prova foi cadastrada no Moodle
    this.buscaTurmaProvaOnlineMoodle(`${environment.loginContexto}/${dadosVestibular.vestibular.ano}/${dadosVestibular.vestibular.codigo}`).subscribe(data=>{
      this.courses = data;
      if(this.courses.courses.length>0){
        // Se a prova foi cadastrada, então eu vejo se o usuário existe no Moodle
        this.buscaUsuarioMoodle(numeroInscricao).subscribe((data)=>{
          this.usuarioMoodle = data;
          if(!(this.usuarioMoodle.users.length>0)){
            // Se ele não existe, precisamos inserir
            this.insereAlunoProvaOnlineMoodle(dadosVestibular,numeroInscricao).subscribe((data)=>{
              (data!=null)?this.idUsuarioMoodle=data[0].id:null;
              if(this.idUsuarioMoodle!=null){
                // Depois de inserir o candidato, precisamos colocá-lo na turma correspondente
                this.insereAlunoTurmaMoodleProvaOnline(this.idUsuarioMoodle).subscribe((data)=>{
                  this.responseInsereAlunoProvaOnlineMoodle = data;
                });
              }
            });
          }else{
            this.atualizaAlunoProvaOnlineMoodle(dadosVestibular,numeroInscricao,this.usuarioMoodle.users[0].id).subscribe((data)=>{
              // Depois de atualizar o candidato, precisamos colocá-lo na turma correspondente
              this.insereAlunoTurmaMoodleProvaOnline(this.usuarioMoodle.users[0].id).subscribe((data)=>{
                this.responseInsereAlunoProvaOnlineMoodle = data;
              });
            });
          }
        });
      }else{
        // Se não existe prova, eu não posso continuar com a inserção
        this.errorHandlerMessage(`Não encontramos provas para este vestibular`);
      }
    });
  }

  buscaUsuarioMoodle(numeroInscricao): Observable<any>{
    return this.http.get(`https://redacaodigital.grupoceuma.com.br/webservice/rest/server.php?wstoken=5f3859aaee7a7d5d5497a804d644bc32&wsfunction=core_user_get_users&moodlewsrestformat=json&criteria[0][key]=username&criteria[0][value]=${numeroInscricao}`)
    .catch(this.errorHandler)
  }

  insereAlunoProvaOnlineMoodle(dadosVestibular,numeroInscricao): Observable<any>{
    const headers= new HttpHeaders();
    headers.delete("content-type");

    const formattedName = dadosVestibular.candidato.nome.split(" ")[0].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    const formattedLastName = dadosVestibular.candidato.nome.split(" ")[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "")

    console.log(formattedName, formattedLastName);

    const url = `https://redacaodigital.grupoceuma.com.br/webservice/rest/server.php?wstoken=5f3859aaee7a7d5d5497a804d644bc32&moodlewsrestformat=json&wsfunction=core_user_create_users&users[0][username]=${numeroInscricao}&users[0][password]=${dadosVestibular.candidato.cpf.replace(/[^\d]+/g, '')}&users[0][firstname]=${numeroInscricao+" - "+formattedName}&users[0][lastname]=${formattedLastName}&users[0][email]=${dadosVestibular.candidato.email}`

    return this.http.get(url, {headers:headers})
    .catch(this.errorHandler);
  }

  atualizaAlunoProvaOnlineMoodle(dadosVestibular, numeroInscricao, idUsuarioMoodle): Observable<any>{
    const headers= new HttpHeaders();
    headers.delete("content-type");
    const url = `https://redacaodigital.grupoceuma.com.br/webservice/rest/server.php?wstoken=5f3859aaee7a7d5d5497a804d644bc32&moodlewsrestformat=json&wsfunction=core_user_update_users&moodlewsrestformat=json&users[0][id]=${idUsuarioMoodle}&users[0][username]=${numeroInscricao}&users[0][customfields][0][type]=inscricao_ead&users[0][customfields][0][value]=${dadosVestibular.vestibular.sigla=='EA'? numeroInscricao:0}&users[0][customfields][2][type]=inscricao_agd&users[0][customfields][2][value]=${dadosVestibular.vestibular.sigla=='AG'? numeroInscricao:0}`

    return this.http.get(url, {headers:headers})
    .catch(this.errorHandler);
  }

  buscaTurmaProvaOnlineMoodle(turma): Observable<any>{
    return this.http.get(`https://redacaodigital.grupoceuma.com.br/webservice/rest/server.php?wstoken=5f3859aaee7a7d5d5497a804d644bc32&moodlewsrestformat=json&wsfunction=core_course_get_courses_by_field&field=shortname&value=${turma}`)
    .catch(this.errorHandler);
  }

  insereAlunoTurmaMoodleProvaOnline(idUsuarioMoodle): Observable<any>{
    const headers= new HttpHeaders();
    headers.delete("content-type");

    const url = `https://redacaodigital.grupoceuma.com.br/webservice/rest/server.php?wstoken=5f3859aaee7a7d5d5497a804d644bc32&moodlewsrestformat=json&wsfunction=enrol_manual_enrol_users&moodlewsrestformat=json&enrolments[0][roleid]=5&enrolments[0][userid]=${idUsuarioMoodle}&enrolments[0][courseid]=${this.courses.courses[0].id}`

    return this.http.get(url,{headers:headers})
    .catch(this.errorHandler);
  }

  logaAlunoMoodle(email): Observable<any>{
    const headers= new HttpHeaders();
    //headers.delete("content-type");

    return this.http.get(`https://redacaodigital.grupoceuma.com.br/webservice/rest/server.php?wstoken=c23468f0eeb4a56cc6add3f8dce6c23d&wsfunction=auth_userkey_request_login_url&user[username]=${email}&moodlewsrestformat=json`,{headers:headers})
    .catch(this.errorHandler);
  }

  async acessaRedacaoDigital(numeroInscricao) {
    let wantsUrl = ''
    if (this.courses != null) {
      wantsUrl = `&wantsurl=https://redacaodigital.grupoceuma.com.br/course/view.php?id=${this.courses.courses[0].id}`;
    }
    await this.logaAlunoMoodle(numeroInscricao).subscribe((data)=>{
      window.location.href = `${data.loginurl}${wantsUrl}`;
    })
  }

  private prepInputInscricao(dadosVestibular: DadosVestibular): any {
    // TODO: utilizar destructuring ou spread operator para tratar os dadosVestibular

    const isEad = dadosVestibular.vestibular.indicacaoEad === 'S';

    // DADOS VESTIBULAR
    const vestibular = {
      ano: dadosVestibular.vestibular.id.ano,
      codigo: dadosVestibular.vestibular.id.codigo,
      valorInscricao: dadosVestibular.vestibular.valorInscricao,
      tipoVestibular: dadosVestibular.vestibular.tipoRaw,
      nome: `${dadosVestibular.vestibular.titulo} ${dadosVestibular.vestibular.anoSemestre}`,
      siglaVestibular: dadosVestibular.vestibular.sigla,
    };

    // DADOS OPCAO CURSO
    const curso = {
      id: dadosVestibular.cursoSelecionado.curso.id,
    };
    let campus;
    if (isEad) {
      campus = {
        id: dadosVestibular.cursoSelecionado.polo.id === '100' ? dadosVestibular.cursoSelecionado.campusTurno.id : dadosVestibular.cursoSelecionado.polo.id,
        apoio: dadosVestibular.cursoSelecionado.campusTurno.id,
      };
    } else {
      campus = {
        id: dadosVestibular.cursoSelecionado.campusTurno.id,
      };
    }
    //console.log(dadosVestibular);
    let responseTurno;
    if(dadosVestibular.cursoSelecionado.campusTurno.turno.turno==undefined){
      responseTurno = dadosVestibular.cursoSelecionado.campusTurno.turno;
    }else{
      responseTurno = dadosVestibular.cursoSelecionado.campusTurno.turno.turno;
    }
    const turno = responseTurno;

    // DADOS DO CANDIDATO
    const candidato: any = {
      cpf: dadosVestibular.candidato.cpf.replace(/[^\d]+/g, ''),
      email: dadosVestibular.candidato.email,
      nome: dadosVestibular.candidato.nome,
      telefone: dadosVestibular.candidato.telefone.replace(/[^\d]+/g, ''),
      dataNascimento: this.convertDatePtBr2Iso(dadosVestibular.candidato.dtNascimento),
      cidade: null,
      aceitaEdital: null
    };

    if (dadosVestibular.agendamento) {
      candidato.usuarioCanhoto = this.getCodeCanhoto(dadosVestibular.agendamento.canhoto);
      candidato.codigoNecessidadeEspecial = this.getCodePne(dadosVestibular.agendamento.tipoPne);
      candidato.necessidadeEspecial = dadosVestibular.agendamento.tipoPne;
    }

    if (dadosVestibular.enem) {
      candidato.aceitaEdital = 'S';
      candidato.usuarioCanhoto = 'N';
      candidato.codigoNecessidadeEspecial = 1;
      candidato.necessidadeEspecial = '';
      candidato.pontuacaoEnem = this.stringUtil.convertPontuacaoEnem(dadosVestibular.enem.pontuacaoEnem);
      candidato.anoEnem = this.stringUtil.getAnoEnem(dadosVestibular.enem.anoEnem);
    }

    if (dadosVestibular.vestibular.sigla === 'ME'||dadosVestibular.vestibular.sigla=== 'MN') {
      candidato.aceitaEdital = 'S';
      candidato.cidade = {
        id: dadosVestibular.candidato.cidade.id,
        nome: dadosVestibular.candidato.cidade.nome,
        uf: dadosVestibular.candidato.uf.sigla,
        nomeUf: dadosVestibular.candidato.uf.nome,
      };
      candidato.rg = dadosVestibular.candidato.rg;
      candidato.orgexp = dadosVestibular.candidato.orgexp;
    }

    if (dadosVestibular.vestibular.sigla === 'CB') {
      candidato.aceitaEdital = 'S';
    }

    // DADOS AGENDAMENTO
    let agendamento: any = null;
    if ((dadosVestibular.vestibular.tipo === 'agendado'||dadosVestibular.vestibular.tipoRaw === 'A')&&(!dadosVestibular.provaOnline)) {
      agendamento = {
        campus: {
          id: dadosVestibular.agendamento.local.codigo,
        },
        codigoHora: dadosVestibular.agendamento.data.codigoHora,
        data: dadosVestibular.agendamento.data.date,
      };
    }

    /**
     * Vestibular ENEM Medicina
     */
    dadosVestibular.contexto = environment.loginContexto;

    let enem = null;
    if (dadosVestibular.enem != null || dadosVestibular.enem !== undefined) {
      enem = {
        ano: dadosVestibular.enem.ano,
        numeroInscricao: dadosVestibular.enem.numeroInscricao,
        pontuacaoEnemE1: dadosVestibular.enem.pontuacaoEnemE1,
        pontuacaoEnemE2: dadosVestibular.enem.pontuacaoEnemE2,
        pontuacaoEnemE3: dadosVestibular.enem.pontuacaoEnemE3,
        pontuacaoEnemE4: dadosVestibular.enem.pontuacaoEnemE4,
        pontuacaoEnemRE: dadosVestibular.enem.pontuacaoEnemRE,
      };
      Object.assign(candidato, {
        celular: dadosVestibular.candidato.celular.replace(/[^\d]+/g, '')
      });
    }

    // entidade principal
    const inputInscricao: any = {
      candidato,
      vestibular,
      curso,
      campus,
      turno,
      agendamento,
      enem
    };

    return inputInscricao;
  }


  /**
   * METODOS AUXILIARES
   */
  private getCodePne(siglaPne: string) {
    /* CESUP as siglas são diferentes */
    if (siglaPne === 'visual') {
      return (this.environment.loginContexto=='CESUP')?3:2;
    }
    if (siglaPne === 'motora') {
      return (this.environment.loginContexto=='CESUP')?4:3;
    }
    if (siglaPne === 'auditiva') {
      return (this.environment.loginContexto=='CESUP')?5:4;
    }
    if (siglaPne === 'outros') {
      return (this.environment.loginContexto=='CESUP')?6:5;
    }
    return (this.environment.loginContexto=='CESUP')?2:1;
  }

  private getCodeCanhoto(canhoto: boolean) {
    if (canhoto) {
      return 'S';
    }
    return 'N';
  }

  private convertDatePtBr2Iso(data: string) {
    if (!data) {
      return '';
    }
    const dataParts = data.split('/');
    return `${dataParts[2]}-${dataParts[1]}-${dataParts[0]}`;
  }

  errorHandler(error: HttpErrorResponse){
    return Observable.throw(error.message || "Server error");
  }

  errorHandlerMessage(error:String){
    return Observable.throw(error || "Server error");
  }
}
